export default {
  props: {
    searching: {
      type: String,
      default: ''
    },
    api: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      todoList: [],
      page: 1,
      cubeScrollOptions: {
        pullDownRefresh: {
          txt: this.$t('common.scroll.refreshSuccess')
        },
        pullUpLoad: {
          txt: {
            more: this.$t('common.scroll.uploadMore'),
            noMore: this.$t('common.scroll.uploadNomore')
          }
        },
        scrollbar: false
      }
    }
  },
  computed: {
    computeTodoList() {
      return this.todoList.map(item => {
        let data = {}
        if (item.docData) {
          item.docData.forEach(element => {
            data[element.title] = element.data
          })
        }
        return {
          id: item.documentId,
          name: item.nodeName,
          status: item.status,
          haveProcess: item.status,
          formId: item.formId,
          documentId: item.documentId,
          processId: item.processId,
          appId: item.appId,
          taskId: item.taskId,
          ...data
        }
      })
    },
    computeTodoColumns() {
      return this.todoList.map(item => {
        let columns = []
        if (item.docData) {
          item.docData.forEach(element => {
            columns.push({
              label: element.title,
              uuid: element.title
            })
          })
        }
        return columns
      })
    }
  },
  watch: {
    searching: function(val, old) {
      this.queryList()
    }
  },
  created() {
    this.queryList(null, true)
  },
  methods: {
    viewDetail(data) {
      this.$router.push({
        name: 'form',
        query: {
          formId: data.formId,
          documentId: data.documentId,
          taskId: data.taskId,
          processId: data.processId,
          appId: data.appId
        }
      })
    },
    onPullingDown(e) {
      // this.$refs.scroll.resetPullUpTxt()
      this.page = 1
      this.queryList()
    },
    onPullingUp(e) {
      this.page += 1
      this.queryList()
    },
    forceUpdate() {
      this.$refs.scroll.forceUpdate()
    },
    queryList(pageIncrese, flag) {
      // this.page = pageIncrese && !this.todoList.length < 1 ? this.page + 1 : 1
      this.page = this.page ? this.page : 1
      const request = {
        ...this.api,
        params: {
          page: this.page,
          pageSize: 10,
          keyWord: this.searching
        }
      }
      this.queryData(request, pageIncrese, flag)
    },
    doSearch() {
      const request = {
        ...this.api,
        params: {
          page: 1,
          pageSize: 10,
          keyWord: this.searching
        }
      }
      this.queryData(request)
    },
    queryData(request, pageIncrese, flag) {
      if (flag) {
        this.$loading.show()
      }
      this.$request(request)
        .asyncThen((resp) => {
          if (request.params.page === 1) {
            this.todoList = []
          }
          if (resp.data.length < 1) {
            this.page -= 1
            this.forceUpdate()
          } else {
            this.todoList = this.todoList.concat(resp.data)
            if (this.todoList.length === resp.total) {
              this.forceUpdate(true)
            }
          }
          this.$loading.hide()
          this.requested && this.requested(resp)
        },
        () => {
          this.forceUpdate()
          this.$loading.hide()
        }
        )
        .asyncErrorCatch(() => {
          this.forceUpdate()
          this.$loading.hide()
        })
    }
  }
}
